export default "__VITE_ASSET__CNKupLCd__"